import {
	readContract,
	getAccount,
	simulateContract,
	writeContract,
} from "wagmi/actions";

// import { ChainAddress, } from "@addresses";
import * as contracts from "@contracts";
import { getChainId, n, } from "./helpers";
import type { Address, AnyToken, ChainId, ExecutableToken, } from "@types";
import {
	getChainedToken,
	getTokenDefinition,
	lookupContractWithABI,
	type TokenDefinition,
} from "@bracket/addressbook";
import { allow, } from "./allow";
import { resolveConnectorId } from "../../../components/ConnectionManager/connectors";
import { wagmiConfig } from "@config";
const { log, } = console;

export declare type ApproveProps = {

	/** the token we are approving expenditure for */
	token: TokenDefinition;

	/** the amount we are approving */
	amount: bigint | number;

	/** the CONTRACT NAME according to @bracket/addressbook */
	contract: "Escrow" | "EscrowRouter";

	/** optionally forced chainid to perform this ERC20 contract */
	chain?: ChainId;

	/** flag this true if this is being called within another resolver, any error will be thrown and you can catch it in the context of your resolver. */
	subcall?: boolean;

}

const isValidChainId = ( value: unknown ): value is 1|42161 => {
	return value === 1 || value === 42161;
}

export const approve = async ({
	token,
	amount,
	chain,
	contract,
	subcall,
}: ApproveProps ): Promise<Address|boolean> => {

	try {

		chain = chain || getChainId();
		if(!isValidChainId(chain))
			throw new Error(`invalid chain id ${chain}`);

		const bigAmount = typeof amount === "bigint" ? amount :  BigInt(amount * Number(`1e${token.decimals}`));
		//@ts-ignore - contract EscrowRouter only exists on chain 1, causing at type error.
		const [address, __] = lookupContractWithABI(chain, contract);
		const [_, abi] = lookupContractWithABI(chain as 1|42161, "ERC20");

		const account = getAccount(wagmiConfig);
		const { request, result  } = await simulateContract(wagmiConfig, {
			address: token.address,
			abi,
			functionName: "approve",
			args: [
				address.toLowerCase(),
				bigAmount,
			],
			account: account.address,
			connector: account.connector
		});


		if(result === true) {
			const hash =-await writeContract(wagmiConfig, request);
			const allowance = await allow({ token, contract, });			
			const start = new Date().getTime();
			await new Promise((res, rej) => {
				if( allowance >= bigAmount ) return res(true);
				const timer = setInterval( async () => {
					const allowance = await allow({ token, contract, });
					if( allowance >= bigAmount ) {
						clearInterval(timer);
						return res(true);
					}
					const now = new Date().getTime();
					if( now - start >= 30000 ) {
						rej(new Error("timeout"));
						return;
					}
				}, 3000);
			}).catch( err => {
				throw new Error("transaction failed: timed out after 30 seconds.");
			});
			//@ts-ignore - the version of wagmi at time of writing this is returning a number, but works.... bug?
			return hash;
		}
		throw new Error("simulation failed.")
	}
	catch ( err ) {
		if( subcall ) throw err;
		// all uses currently are a subcall so we expect subcall to be true
		throw new Error(`EscrowStore::resolvers::approve failed obtaining approval (subcall expected true! set it) for token "${token.label}" on chain "${chain}" :: ${err instanceof Error ? err?.message : "no error provided" }`);
	}
}
